import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IYuklemeOlusturmaExcel_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IYuklemeOlusturmaExcel_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  Get_Helpers_UserInfoByUserName: any[];
  Get_Helpers_UserInfoByUserName_dummy: any[];
  GetUploadFileName: string;
  GetUploadFileName_dummy: string;
  YuklemePlan_Excel_DeleteTempTable: any[];
  YuklemePlan_Excel_DeleteTempTable_dummy: any[];
  UploadFile: any;
  UploadFile_dummy: any;
  ImportExcelBase64: string;
  ImportExcelBase64_dummy: string;
  Check_MasterDef_InExcel: any[];
  Check_MasterDef_InExcel_dummy: any[];
  YuklemePlan_Save_FromExcel: any[];
  YuklemePlan_Save_FromExcel_dummy: any[];
  YuklemePlan_Get_Excel_TedarikciMailBilgi: any[];
  YuklemePlan_Get_Excel_TedarikciMailBilgi_dummy: any[];
  GetMailBody_TedarikciAtamaBildirim: string;
  GetMailBody_TedarikciAtamaBildirim_dummy: string;
  SendMail: boolean;
  SendMail_dummy: boolean;
  ForEach1: YuklemePlan_Get_Excel_TedarikciMailBilgi;
  ForEach1_dummy: YuklemePlan_Get_Excel_TedarikciMailBilgi;
  ExportExcel: any;
  ExportExcel_dummy: any;
  isComp699160Visible: "visible" | "hidden";
  isComp259893Visible: "visible" | "hidden";
  isComp217851Visible: "visible" | "hidden";
}

export class YuklemeOlusturmaExcel_ScreenBase extends React.PureComponent<
  IYuklemeOlusturmaExcel_ScreenProps,
  any
> {
  yuklemeolusturmaexcel_311338_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "585b6303-ac4a-473f-8893-c915ede3bf84",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "08eb6581-d950-4fd3-b4b6-07fca00af3db",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 980166,
          PropertyName: "value",
          Value: "Aruna Nakliye Yönetim Portalı",
        },
        {
          Id: 162294,
          PropertyName: "value",
          Value: "EXCELDEN YÜKLEME PLANI AKTARIMI",
        },
        { Id: 484780, PropertyName: "label", Value: "Yükleme Planı Aktar" },
        {
          Id: 612771,
          PropertyName: "value",
          Value: "AKTARIMDA HATALAR OLUŞTU",
        },
        { Id: 357177, PropertyName: "label", Value: "Hataları Kaydet" },
        { Id: 402617, PropertyName: "title", Value: "Yükleme No" },
        { Id: 576328, PropertyName: "value", Value: "[datafield:yuklemeno]" },
        { Id: 385817, PropertyName: "title", Value: "Hatali Alan" },
        {
          Id: 496656,
          PropertyName: "value",
          Value: "[datafield:tanimsizalan]",
        },
        { Id: 872262, PropertyName: "title", Value: "Hatali Kod" },
        { Id: 692122, PropertyName: "value", Value: "[datafield:tanimsizkod]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  ForEach1: any[];

  constructor(props) {
    super(props);
    this.yuklemeolusturmaexcel_311338_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      ReadFromSessionStorage: "",
      Get_Helpers_UserInfoByUserName: [],
      GetUploadFileName: "",
      YuklemePlan_Excel_DeleteTempTable: [],
      UploadFile: "",
      ImportExcelBase64: "",
      Check_MasterDef_InExcel: [],
      YuklemePlan_Save_FromExcel: [],
      YuklemePlan_Get_Excel_TedarikciMailBilgi: [],
      ForEach: false,
      ExportExcel: "",
      isComp699160Visible: "hidden",
      isComp259893Visible: "hidden",
      isComp217851Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("yuklemeolusturmaexcel", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.YuklemeOlusturmaExcelPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("yuklemeolusturmaexcel", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("yuklemeolusturmaexcel", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.YuklemeOlusturmaExcelPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  YuklemeOlusturmaExcelPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("FirmaNo", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YuklemeOlusturmaExcelPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YuklemeOlusturmaExcelPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeOlusturmaExcel/YuklemeOlusturmaExcelPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Helpers_UserInfoByUserName =
      result?.data.get_Helpers_UserInfoByUserName;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YuklemeOlusturmaExcelPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeOlusturmaExcelPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp699160Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.Check_MasterDef_InExcel !== undefined
            ? stateVars.Check_MasterDef_InExcel?.length > 0
              ? stateVars.Check_MasterDef_InExcel[0].tanimsizKod
              : null
            : this.state.Check_MasterDef_InExcel?.length > 0
            ? this.state.Check_MasterDef_InExcel[0].tanimsizKod
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp259893Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.Check_MasterDef_InExcel !== undefined
            ? stateVars.Check_MasterDef_InExcel?.length > 0
              ? stateVars.Check_MasterDef_InExcel[0].tanimsizKod
              : null
            : this.state.Check_MasterDef_InExcel?.length > 0
            ? this.state.Check_MasterDef_InExcel[0].tanimsizKod
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp217851Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.Check_MasterDef_InExcel !== undefined
            ? stateVars.Check_MasterDef_InExcel?.length > 0
              ? stateVars.Check_MasterDef_InExcel[0].tanimsizKod
              : null
            : this.state.Check_MasterDef_InExcel?.length > 0
            ? this.state.Check_MasterDef_InExcel[0].tanimsizKod
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  YuklemeOlusturmaExcelComponent_491786_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaTipi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaTipi
            : null
        ),
        "1"
      )
    ) {
      KuikaAppManager.showSpinner(this);

      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.YuklemeOlusturmaExcelComponent_491786_onClick1_,
        "YuklemeOlusturmaExcel",
        "LeftMenu",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "29182",
        null,
        "left",
        "true",
        "380px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemeOlusturmaExcelComponent_491786_onClick1_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YuklemeOlusturmaExcelComponent_491786_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaTipi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaTipi
            : null
        ),
        "2"
      )
    ) {
      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "YuklemeOlusturmaExcel",
        "LeftMenuYukVeren",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "867734",
        null,
        "left",
        "true",
        "380px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  YuklemeOlusturmaExcelComponent_484780_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      _BaseName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "YuklemePlan_ImportExcel",
          "string"
        ),
        "string"
      ),
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        "string"
      ),
      KullaniciId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "string"
      ),
      TableName_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.GetUploadFileName),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeOlusturmaExcel/YuklemeOlusturmaExcelComponent_484780_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUploadFileName = result?.data.getUploadFileName;
    stateVars.YuklemePlan_Excel_DeleteTempTable =
      result?.data.yuklemePlan_Excel_DeleteTempTable;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemeOlusturmaExcelComponent_484780_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeOlusturmaExcelComponent_484780_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.UploadFile = (
      (await ReactSystemFunctions.uploadFileWithInfo(
        ReactSystemFunctions.convertToTypeByName("", "string")
      )) as any
    ).data;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemeOlusturmaExcelComponent_484780_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YuklemeOlusturmaExcelComponent_484780_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      excelBase64_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.UploadFile?.data),
        "string"
      ),
      tableName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetUploadFileName),
        "string"
      ),
      primaryKeyName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Id", "string"),
        "string"
      ),
      TableName_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetUploadFileName),
        "string"
      ),
      FirmaNo_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeOlusturmaExcel/YuklemeOlusturmaExcelComponent_484780_onClick2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ImportExcelBase64 = result?.data.importExcelBase64;
    stateVars.Check_MasterDef_InExcel = result?.data.check_MasterDef_InExcel;

    stateVars.isComp699160Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.Check_MasterDef_InExcel !== undefined
            ? stateVars.Check_MasterDef_InExcel?.length > 0
              ? stateVars.Check_MasterDef_InExcel[0].tanimsizKod
              : null
            : this.state.Check_MasterDef_InExcel?.length > 0
            ? this.state.Check_MasterDef_InExcel[0].tanimsizKod
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp259893Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.Check_MasterDef_InExcel !== undefined
            ? stateVars.Check_MasterDef_InExcel?.length > 0
              ? stateVars.Check_MasterDef_InExcel[0].tanimsizKod
              : null
            : this.state.Check_MasterDef_InExcel?.length > 0
            ? this.state.Check_MasterDef_InExcel[0].tanimsizKod
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp217851Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.Check_MasterDef_InExcel !== undefined
            ? stateVars.Check_MasterDef_InExcel?.length > 0
              ? stateVars.Check_MasterDef_InExcel[0].tanimsizKod
              : null
            : this.state.Check_MasterDef_InExcel?.length > 0
            ? this.state.Check_MasterDef_InExcel[0].tanimsizKod
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemeOlusturmaExcelComponent_484780_onClick3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeOlusturmaExcelComponent_484780_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      TableName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetUploadFileName),
        "string"
      ),
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.Check_MasterDef_InExcel !== undefined
            ? stateVars.Check_MasterDef_InExcel?.length > 0
              ? stateVars.Check_MasterDef_InExcel[0].tanimsizKod
              : null
            : this.state.Check_MasterDef_InExcel?.length > 0
            ? this.state.Check_MasterDef_InExcel[0].tanimsizKod
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "YuklemeOlusturmaExcel/YuklemeOlusturmaExcelComponent_484780_onClick3_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.YuklemePlan_Save_FromExcel =
        result?.data.yuklemePlan_Save_FromExcel;
      formVars.yuklemeolusturmaexcel_963513_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_Save_FromExcel !== undefined
            ? stateVars.YuklemePlan_Save_FromExcel?.length > 0
              ? stateVars.YuklemePlan_Save_FromExcel[0].basariliAktarimBilgi
              : null
            : this.state.YuklemePlan_Save_FromExcel?.length > 0
            ? this.state.YuklemePlan_Save_FromExcel[0].basariliAktarimBilgi
            : null
        );
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemeOlusturmaExcelComponent_484780_onClick4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemeOlusturmaExcelComponent_484780_onClick4_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeOlusturmaExcelComponent_484780_onClick4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
    };

    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.Check_MasterDef_InExcel !== undefined
            ? stateVars.Check_MasterDef_InExcel?.length > 0
              ? stateVars.Check_MasterDef_InExcel[0].tanimsizKod
              : null
            : this.state.Check_MasterDef_InExcel?.length > 0
            ? this.state.Check_MasterDef_InExcel[0].tanimsizKod
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "YuklemeOlusturmaExcel/YuklemeOlusturmaExcelComponent_484780_onClick4_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.YuklemePlan_Get_Excel_TedarikciMailBilgi =
        result?.data.yuklemePlan_Get_Excel_TedarikciMailBilgi;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemeOlusturmaExcelComponent_484780_onClick5_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemeOlusturmaExcelComponent_484780_onClick5_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeOlusturmaExcelComponent_484780_onClick_foreach5 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      IsSayisi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.ForEach1?.sayisi),
        "string"
      ),
      FirmaAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaAdi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaAdi
            : null
        ),
        "string"
      ),
      YuklemeEmirListesi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach1?.yuklemeNoListe),
        "string"
      ),
      templateId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      receivers_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach1?.ePosta),
        "string"
      ),
      subject_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "Yeni Yükleme Plan Atama Bildirimi",
          "string"
        ),
        "string"
      ),
      sender_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      cc_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      bcc_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      language_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      body_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetMailBody_TedarikciAtamaBildirim
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeOlusturmaExcel/YuklemeOlusturmaExcelComponent_484780_onClick_foreach5",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetMailBody_TedarikciAtamaBildirim =
      result?.data.getMailBody_TedarikciAtamaBildirim;
    stateVars.SendMail = result?.data.sendMail;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  YuklemeOlusturmaExcelComponent_484780_onClick5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.Check_MasterDef_InExcel !== undefined
            ? stateVars.Check_MasterDef_InExcel?.length > 0
              ? stateVars.Check_MasterDef_InExcel[0].tanimsizKod
              : null
            : this.state.Check_MasterDef_InExcel?.length > 0
            ? this.state.Check_MasterDef_InExcel[0].tanimsizKod
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (
        ReactSystemFunctions.value(
          this,
          this.state.YuklemePlan_Get_Excel_TedarikciMailBilgi
        )?.length
      ) {
        for (let item of ReactSystemFunctions.value(
          this,
          this.state.YuklemePlan_Get_Excel_TedarikciMailBilgi
        )) {
          this.ForEach1 = item;
          await this.YuklemeOlusturmaExcelComponent_484780_onClick_foreach5();
        }
      }

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemeOlusturmaExcelComponent_484780_onClick6_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemeOlusturmaExcelComponent_484780_onClick6_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YuklemeOlusturmaExcelComponent_484780_onClick6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_Save_FromExcel !== undefined
            ? stateVars.YuklemePlan_Save_FromExcel?.length > 0
              ? stateVars.YuklemePlan_Save_FromExcel[0].result
              : null
            : this.state.YuklemePlan_Save_FromExcel?.length > 0
            ? this.state.YuklemePlan_Save_FromExcel[0].result
            : null
        ),
        "OK"
      )
    ) {
      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(
        "MesajGoster",
        "HeaderText",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.convertToTypeByName(
            "Yukleme Plan Aktarım Hataları",
            "string"
          ),
          "string"
        )
      );
      KuikaAppManager.addToPageInputVariables(
        "MesajGoster",
        "MessageToUser",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.toString(
            this,
            stateVars.YuklemePlan_Save_FromExcel !== undefined
              ? stateVars.YuklemePlan_Save_FromExcel?.length > 0
                ? stateVars.YuklemePlan_Save_FromExcel[0].result
                : null
              : this.state.YuklemePlan_Save_FromExcel?.length > 0
              ? this.state.YuklemePlan_Save_FromExcel[0].result
              : null
          ),
          "string"
        )
      );

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.YuklemeOlusturmaExcelComponent_484780_onClick7_,
        "YuklemeOlusturmaExcel",
        "MesajGoster",
        "",
        "9924ef5f-4b84-4200-b624-8d76348c7686",
        "840484",
        null,
        null,
        "true",
        "800px",
        "70vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemeOlusturmaExcelComponent_484780_onClick7_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YuklemeOlusturmaExcelComponent_484780_onClick7_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_Save_FromExcel !== undefined
            ? stateVars.YuklemePlan_Save_FromExcel?.length > 0
              ? stateVars.YuklemePlan_Save_FromExcel[0].result
              : null
            : this.state.YuklemePlan_Save_FromExcel?.length > 0
            ? this.state.YuklemePlan_Save_FromExcel[0].result
            : null
        ),
        "OK"
      )
    ) {
      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.YuklemeOlusturmaExcelComponent_484780_onClick8_,
        "YuklemeOlusturmaExcel",
        "YuklemeListesiv2Ozet",
        "",
        "currentPage",
        null,
        null,
        null,
        null,
        null,
        null,
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemeOlusturmaExcelComponent_484780_onClick8_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YuklemeOlusturmaExcelComponent_484780_onClick8_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.Check_MasterDef_InExcel !== undefined
            ? stateVars.Check_MasterDef_InExcel?.length > 0
              ? stateVars.Check_MasterDef_InExcel[0].tanimsizKod
              : null
            : this.state.Check_MasterDef_InExcel?.length > 0
            ? this.state.Check_MasterDef_InExcel[0].tanimsizKod
            : null
        ),
        true
      )
    ) {
      formVars.yuklemeolusturmaexcel_963513_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_Save_FromExcel !== undefined
            ? stateVars.YuklemePlan_Save_FromExcel?.length > 0
              ? stateVars.YuklemePlan_Save_FromExcel[0].basariliAktarimBilgi
              : null
            : this.state.YuklemePlan_Save_FromExcel?.length > 0
            ? this.state.YuklemePlan_Save_FromExcel[0].basariliAktarimBilgi
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemeOlusturmaExcelComponent_484780_onClick9_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemeOlusturmaExcelComponent_484780_onClick9_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YuklemeOlusturmaExcelComponent_484780_onClick9_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_311338 =
      stateVars.Check_MasterDef_InExcel ?? this.state.Check_MasterDef_InExcel;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YuklemeOlusturmaExcelComponent_357177_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      value_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.Check_MasterDef_InExcel),
        "any"
      ),
      header_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      footer_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      columns_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeOlusturmaExcel/YuklemeOlusturmaExcelComponent_357177_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ExportExcel = result?.data.exportExcel;
    ReactSystemFunctions.downloadFile(result?.data?.exportExcel);
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [29182, 867734, 840484] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.YuklemeOlusturmaExcelPageInit();
    }
    if (diId == 29182) {
      isErrorOccurred =
        await this.YuklemeOlusturmaExcelComponent_491786_onClick1_();
      if (isErrorOccurred) return true;
    } else if (diId == 840484) {
      isErrorOccurred =
        await this.YuklemeOlusturmaExcelComponent_484780_onClick7_();
      if (isErrorOccurred) return true;
    }
  }
}
